import React, { useState } from "react";
import "./TwoColumnCollapser.css";

interface ICollapserStyles{
    wrapper?: string,
    leftSide?: string,
    leftContent?: string,
    rightSide?: string,
    rightContent?: string,
}

export const TwoColumnCollapser = ({leftContent, rightContent, collapserState, styles}: {leftContent: React.ReactNode, rightContent: React.ReactNode, collapserState: ('left' | 'right' | 'both'), styles?: ICollapserStyles}) => {
    //const [collapserState, setCollapserState] = useState('both');
    return (
        <div className={`commonTwoColumnCollapser commonTwoColumnCollapser--${collapserState} ${styles.wrapper || ''} ${styles.wrapper? styles.wrapper+'--'+collapserState:''}`}>
            <div className={`commonTwoColumnCollapser_side commonTwoColumnCollapser_left ${styles.leftSide || ''}`}>
                <div className={`commonTwoColumnCollapser_content ${styles.leftContent || ''}`}>
                    {leftContent}
                </div>
            </div>
            <div className={`commonTwoColumnCollapser_side commonTwoColumnCollapser_right ${styles.rightSide || ''}`}>
                <div className={`commonTwoColumnCollapser_content ${styles.rightContent || ''}`}>
                    {rightContent}
                </div>
            </div>   
        </div>
    )
}